/* COVA footer: menus are open columns on desktop and an accordion on mobile */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-footer]', function (footer) {
      var mq = window.matchMedia('(min-width: 768px)');
      var details = footer.querySelectorAll('.cv-footer__menu details');
      function sync() { details.forEach(function (d) { d.open = mq.matches; }); }
      sync();
      if (mq.addEventListener) mq.addEventListener('change', sync);
      footer.querySelectorAll('.cv-footer__menu summary').forEach(function (s) {
        s.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
      });
    });
  });
})();
